var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5002 1.66679C15.5002 1.88013 15.4185 2.09346 15.256 2.25596L8.58937 8.92263C8.26354 9.24846 7.73688 9.24846 7.41104 8.92263L0.744375 2.25596C0.418542 1.93013 0.418542 1.40346 0.744375 1.07763C1.07021 0.751794 1.59687 0.751794 1.92271 1.07763L8.00021 7.15513L14.0777 1.07763C14.4035 0.751794 14.9302 0.751794 15.256 1.07763C15.4185 1.24013 15.5002 1.45346 15.5002 1.66679Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToBottom);
export default __webpack_public_path__ + "static/media/arrowToBottom.4f8d40a5.svg";
export { ForwardRef as ReactComponent };